import { toneFor } from "../lib/tone";

export const ScoreGauge = ({ score, height = "h-2.5", testId }) => {
  const tone = toneFor(score);
  return (
    <div className="relative w-full" data-testid={testId} role="meter" aria-valuemin={0} aria-valuemax={100} aria-valuenow={score} aria-label={`Sentiment ${score} of 100, ${tone.label}`}>
      <div className={`gauge-track ${height} w-full rounded-full`} />
      <div className="absolute inset-y-0 left-1/2 w-px bg-slate-400/50" />
      <div
        className="gauge-marker absolute top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full border-[3px] border-white shadow-md"
        style={{ left: `${Math.min(98, Math.max(2, score))}%`, backgroundColor: tone.hex }}
      />
    </div>
  );
};

export const TonePill = ({ score, testId }) => {
  const tone = toneFor(score);
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1.5 rounded-full border px-2.5 py-0.5 text-xs font-medium ${tone.pill}`}>
      <span className="h-1.5 w-1.5 rounded-full" style={{ backgroundColor: tone.hex }} />
      {tone.label}
    </span>
  );
};
